module.exports = __webpack_public_path__ + "static/media/privacy-statement.2d9f4e50.pdf";